module.exports = __webpack_public_path__ + "static/img/10001.22ee9bc1.png";